@if (decisionCount > 0 || minuteCount > 0 || itemCount > 0 || objCount > 0) {
    <div class="d-inline-flex align-items-center">
        @if (showTotalBadgeOnly) {
            <span class="badge bg-primary agenda-counter"
                  [adaptTooltip]="totalBadgeTooltip">{{ decisionCount + minuteCount + itemCount + objCount }}</span>
        } @else {
            @if (decisionCount > 0) {
                <div class="d-inline-flex align-items-center"
                     adaptTooltip="Number of decisions">
                    <i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Decision]"></i>
                    <span class="me-1">{{ decisionCount }}</span>
                </div>
            }
            @if (minuteCount > 0) {
                <div class="d-inline-flex align-items-center"
                     adaptTooltip="Number of minutes">
                    <i [ngClass]="MeetingNoteIconClass[MeetingNoteType.Minute]"></i>
                    <span class="me-1">{{ minuteCount }}</span>
                </div>
            }
            @if (itemCount > 0) {
                <div class="d-inline-flex align-items-center"
                     adaptTooltip="Number of actions">
                    <i [ngClass]="MeetingItemIconClass"></i>
                    <span class="me-1">{{ itemCount }}</span>
                </div>
            }
        }
    </div>
}
